import { Box, Button, IconButton, Typography, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'

import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import ConfirmDialog from '../../components/common/ConfirmDialog'
import AddEditAdmin from '../../components/admin/AddEditAdmin'
import CustomTable from '../../components/common/custom-table/CustomTable'
import noAdminsImg from '../../assets/no-subadmins.svg'
import { Icons } from '../../utils/utilities'
import api from '../../service/api'
import { useUserStore } from '../../store/user.store'
import BlockMessage from '../../components/common/BlockMessage'


const ManageAccounts = () => {
    const [deleteConfirmDialogState, setDeleteConfirmDialogState] = useState( false )
    const [deleteSelectedUserId, setDeleteSelectedUserId] = useState( null )
    const [hasPermission, setHasPermission] = useState( true )
    const [adminUsers, setAdminUsers] = useState( [] )
    const [adminUser, setAdminUser] = useState( null )
    const [isLoading, setIsLoading] = useState( true )
    const [mode, setMode] = useState( "manage" )

    const { border, shadows, layout } = useTheme()

    const UserStore = useUserStore()

    const deleteAdminUser = async ( id ) => {
        try {
            await api.deleteSubAdminAccount( id )
            const res = await api.getSubAdminAccounts()
            setAdminUsers( res.data.data )
        } catch ( err ) {
            console.log( err )
        }
    }

    const columns = useMemo( () => [
        { field: "index", index: true, name: "Sl.No.", maxWidth: "100px", padding: "10px 20px", align: "left" },
        { field: "user_name", name: "Username", maxWidth: "200px", align: "left" },
        { field: "user_email", name: "E-mail", maxWidth: "200px", align: "left", styles: { "::after": {} } },
        {
            field: "user_id", renderCell: ( row ) => {
                return (
                    <Box display="flex" justifyContent="flex-end" gap="10px" alignItems="center">
                        <IconButton size="small" sx={{ padding: "5px" }} color="secondary" onClick={() => { setAdminUser( row ); setMode( "edit" ) }}>
                            {Icons.default.ManageAccounts}
                        </IconButton>
                        <IconButton size="small" onClick={() => { setDeleteSelectedUserId( row.user_id ); setDeleteConfirmDialogState( true ) }} sx={{ padding: "5px" }} color="error" >
                            {Icons.default.DeleteIcon}
                        </IconButton>
                    </Box>
                )
            },
            name: "",
            maxWidth: "200px",
            align: "right",
            padding: "10px 20px",
        },
    ], [] )


    useEffect( () => {
        const getAdmins = async () => {
            try {
                const res = await api.getSubAdminAccounts()
                setAdminUsers( res.data.data )
            } catch ( err ) {
                console.log( err )
            } finally {
                setIsLoading( false )
            }
        }

        if ( UserStore.getUser.user_role === 'SUBADMIN' && !UserStore.getUser.user_permissions.manage_accounts ) {
            setHasPermission( false )
        } else
            getAdmins()
    }, [mode, UserStore] )

    return hasPermission ? (
        <Box padding={layout.pagePadding} overflow="auto" display="flex" flexDirection="column" flexGrow={1}>
            <ConfirmDialog status={deleteConfirmDialogState} confirmAction={
                () => {
                    try {
                        deleteAdminUser( deleteSelectedUserId )
                        setDeleteConfirmDialogState( false )
                    } catch ( err ) { }

                }} cancelAction={() => { setDeleteConfirmDialogState( false ) }} actionName="Delete" message="This account can not be retrived" isReversible={false} />
            <Box sx={{ minHeight: !isLoading && "350px", flexGrow: !isLoading && mode === "manage" && adminUsers.length > 0 ? "1" : "initial", display: "flex", flexDirection: "column", gap: layout.sectionsGap }}>

                {( mode === "add" || mode === "edit" ) && <AddEditAdmin mode={mode} setMode={setMode} user={adminUser} />}

                <Box display="flex" gap="20px" justifyContent="space-between">
                    <Box>
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Admins</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Manage admins permissions</Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <Button disableElevation sx={{ textTransform: "capitalize" }} variant="contained" startIcon={Icons.default.AddIcon} color="primary" onClick={() => { if ( mode === "add" || mode === "edit" ) setMode( "manage" ); else setMode( "add" ) }}>
                            Add new user
                        </Button>
                    </Box>
                </Box>
                {!isLoading && adminUsers.length > 0 &&
                    <CustomTable containerStyles={{ border: border[1], borderRadius: layout.borderRadius, boxShadow: shadows[1] }} pageSize={50} columns={columns} data={adminUsers} />
                }
                {adminUsers.length === 0 && !isLoading && mode === "manage" &&
                    <Box padding="20px" flexGrow={1} justifyContent="center" display="flex" alignItems="center" flexDirection="column" gap="10px" bgcolor="#eee">
                        <img src={noAdminsImg} width="200px" alt="No subadmins added" />
                        <Typography variant='subtitle2' color="textSecondary">No subadmin accounts!</Typography>
                        <Button onClick={() => { if ( mode === "add" || mode === "edit" ) setMode( "manage" ); else setMode( "add" ) }} startIcon={Icons.default.AddIcon} variant='outlined' sx={{ textTransform: "capitalize" }}>Add user</Button>
                    </Box>
                }
                {isLoading && <DataLoadingSpinner waitingMessage="Loading accounts please wait..." />}
            </Box>
        </Box> ) : ( <Box flexGrow={1} padding={layout.pagePadding}>
            <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
        </Box> )
}

export default ManageAccounts
